export default "__VITE_ASSET__BNMaJktc__"